import React, { ReactElement } from 'react';
import { Button, LoaderButton } from 'idsk-react-components';
import './processTerminateButtons.scss';
import { BackButton, ConfirmModal } from 'slovlex-idsk-react-components';

interface Props {
  onClick: () => void;
  loading: boolean;
}

const ProcessTerminateButtons = ({
  onClick,
  loading,
}: Props): ReactElement => (
  <div className="process-terminate-buttons__container">
    <ConfirmModal
      question="Naozaj si prajete ukončiť proces?"
      description={'Po ukončení procesu už nebude možné vykonávať pracovné kroky a aktuálne štádium materiálu'
        + ' bude nastavené na "Proces ukončený".'}
      cancelButtonText="Nie"
      confirmButton={
        (
          <Button
            buttonStyle="action"
            size="large"
          >
            Áno
          </Button>
        )
      }
      openButton={(
        <LoaderButton
          loading={loading}
          className="process-terminate-buttons__ukoncit"
          size="large"
          disableOutsideClickWhileLoading
        >
          Ukončiť proces
        </LoaderButton>
      )}
      doAfterConfirm={onClick}
    />
    <BackButton disabled={loading} />
  </div>
);
export default ProcessTerminateButtons;
